import { LayoutFunction } from '@/types/layout'

export default {} as Record<string, Record<string, LayoutFunction>>
